export const colorPickerConstants = {
  colorMap: {
    '#E53935': 'Red',
    '#9C27B0': 'Purple',
    '#FF9800': 'Orange',
    '#2196F3': 'Blue',
    '#4CAF50': 'Green',
    '#FF5722': 'Deep Orange',
    '#795548': 'Brown',
    '#607D8B': 'Blue Grey',
    '#E91E63': 'Pink',
    '#673AB7': 'Deep Purple',
    '#3F51B5': 'Indigo',
    '#03A9F4': 'Light Blue',
    '#00BCD4': 'Cyan',
    '#009688': 'Teal',
    '#8BC34A': 'Light Green',
    '#CDDC39': 'Lime',
    '#9E9E9E': 'Grey',
  },
  getColorName(colorHex) {
    return colorPickerConstants.colorMap[colorHex.toUpperCase()] || colorHex;
  },

  get colorPalette() {
    return Object.keys(colorPickerConstants.colorMap);
  },
};
